import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { DotChartOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UIHelper from 'helpers/UIHelper';
import useListCompany from './useListCompany';
import Filters from '../../../../../components/filters';

const ListCompany = () => {
  const {
    listCompany,
    columnsListCompany,
    handleDownloadExcelSingle,
    loading,
    filters,
  } = useListCompany();
  const { pathname } = useLocation();
  let { id } = useParams();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('SONDAGGIO A RISPOSTA CHIUSA INSEGNA')}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcelSingle}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Link to={UIHelper.getListRoute(pathname, 2) + `/answers/${id}`}>
              <Button big icon={<DotChartOutlined />}>
                {t('Risultati')}
              </Button>
            </Link>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters allFilters filters={filters} />
        <Divider />
        <Table
          columns={UIHelper.assignTire(columnsListCompany)}
          dataSource={listCompany}
          pagination={{
            pageSize: 10,
            position: ['bottomCenter'],
            hideOnSinglePage: true,
            showSizeChanger: false,
          }}
        />
      </div>
    </>
  );
};

export default ListCompany;
